export const EMAIL_PATTERN_REGEX = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/